export default "__VITE_ASSET__dprfm8ar__"